<template>
  <div class="ec-tag-input-wrapper">
    <label v-if="label" class="ec-form-label">
      {{ label }}
      <span v-if="required" class="ec-form-label__required">*</span>
    </label>
    <div
      class="ec-tag-input"
      :class="{
        'ec-tag-input--error': error,
        'ec-tag-input--disabled': disabled,
      }"
      @click="focusInput"
    >
      <span v-for="(tag, i) in tags" :key="i" class="ec-tag-input__tag">
        <span class="ec-tag-input__tag-text">{{ tag }}</span>
        <button
          v-if="!disabled"
          type="button"
          class="ec-tag-input__tag-remove"
          @click.stop="removeTag(i)"
        >
          <i class="bi bi-x" />
        </button>
      </span>
      <input
        ref="inputRef"
        v-model="inputValue"
        type="text"
        class="ec-tag-input__input"
        :placeholder="tags.length === 0 ? placeholder : ''"
        :disabled="disabled"
        @keydown="handleKeydown"
        @paste="handlePaste"
        @blur="handleBlur"
      />
    </div>
    <div v-if="error" class="ec-form-error">{{ error }}</div>
    <small v-if="hint && !error" class="ec-form-hint">{{ hint }}</small>
  </div>
</template>

<script>
export default {
  name: 'EcTagInput',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: [Array, String], default: () => [] },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
    required: { type: Boolean, default: false },
    separator: { type: String, default: ',' },
  },

  data() {
    return {
      inputValue: '',
    }
  },

  computed: {
    tags() {
      if (Array.isArray(this.value)) return this.value
      if (typeof this.value === 'string' && this.value.trim()) {
        return this.value.split(this.separator).map((s) => s.trim()).filter(Boolean)
      }
      return []
    },
  },

  methods: {
    addTag(value) {
      var raw = (value !== undefined ? value : this.inputValue).trim()
      if (!raw) return

      var newTags = raw.split(this.separator).map((s) => s.trim()).filter(Boolean)
      var current = this.tags.slice()

      newTags.forEach((tag) => {
        if (!current.includes(tag)) current.push(tag)
      })

      this.$emit('input', current)
      this.inputValue = ''
    },

    removeTag(index) {
      if (this.disabled) return
      var current = this.tags.slice()
      current.splice(index, 1)
      this.$emit('input', current)
    },

    handleKeydown(e) {
      if (e.key === 'Enter' || e.key === this.separator) {
        e.preventDefault()
        this.addTag()
      }
      if (e.key === 'Backspace' && !this.inputValue && this.tags.length) {
        this.removeTag(this.tags.length - 1)
      }
    },

    handlePaste(e) {
      var text = e.clipboardData ? e.clipboardData.getData('text') : ''
      if (text.includes(this.separator) || text.includes('\n')) {
        e.preventDefault()
        this.addTag(text.replace(/\n/g, this.separator))
      }
    },

    handleBlur() {
      if (this.inputValue.trim()) this.addTag()
    },

    focusInput() {
      this.$refs.inputRef && this.$refs.inputRef.focus()
    },
  },
}
</script>
